<template lang="pug">
.ads-page-card(:class="[sizeClass]" @click="redirect")
  .ads-card-content(v-if="ad.content" v-html="ad.content")
  template(v-else)
    .title.is-6(v-if="ad.title") {{ ad.title }}
    img.img(:src="ad.imageUrl" v-if="ad.imageUrl")
</template>

<script>
export default {
  name: "Ad",
  props: {
    type: String,
    ad: Object
  },
  methods: {
    redirect() {
      if (this.ad.url) window.location = this.ad.url;
    }
  },
  computed: {
    sizeClass() {
      switch (this.type) {
        case "WS":
          return "wide-sky";
        case "S":
          return "sky";
        case "SQ":
          return "square";
        case "VB":
          return "vertical-banner";
        case "MR":
          return "medium-rectangle";
        case "LR":
          return "large-rectangle";
        case "HB":
          return "half-banner";
        case "FB":
          return "full-banner";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ads-page-card {
  cursor: pointer;
  // background-color: var(--tab-color);
  color: var(--font-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    padding: 1rem;
    margin: 0;
  }

  .img {
    max-width: 100%;
  }

  &.sky {
    width: 120px;
    max-height: 600px;
  }

  &.wide-sky {
    width: 160px;
    max-height: 600px;
  }

  &.square {
    width: 250px;
    max-height: 250px;
  }

  &.vertical-banner {
    width: 120px;
    max-height: 240px;
  }

  &.medium-rectangle {
    width: 300px;
    max-height: 250px;
  }

  &.large-rectangle {
    width: 336px;
    max-height: 280px;
  }

  &.half-banner {
    min-width: 234px;
    min-height: 60px;
  }

  &.full-banner {
    min-width: 468px;
    min-height: 60px;
  }
}
</style>
